'use es6';

import { FetchBusinessObjectivesRequestTypes } from '../actions/BusinessObjectiveActions';
import { reduceBusinessObjectiveResponse } from 'pricing-pages-lib/reducers/BusinessObjectives';
const initialState = {};

const BusinessObjectives = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchBusinessObjectivesRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return Object.assign({}, state, {}, reduceBusinessObjectiveResponse({
          data
        }));
      }

    default:
      return state;
  }
};

export default BusinessObjectives;